module.exports = __webpack_public_path__ + "static/media/lens_rchic.d1637635.png";